import { TableCell, useMediaQuery, useTheme } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { accessHistoryApi } from 'api/authApi';
import { getCustomerReservationList } from 'api/reservationApi';
import { DataTableColumn } from 'components/organismos/DataTable/interface';
import { COMPANY_CODE_POST_MESSAGE, DOMAIN_POST_MESSAGE } from 'constants/configPostMessage';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getLocalStorage, getSessionStorage } from 'utility/browserStorageUtil';
import MypageReservationListDesktop from './desktop';
import MypageReservationListMobile from './mobile';
import useStyles from './style';

export interface CustomerReservation {
  reservationId: string;
  desiredTime: string;
  orgName: string;
  orgId: string;
  contractCourseId: string;
}

const verticalLineStyle = {
  borderLeft: '1px solid rgba(0, 0, 0, 0.14)',
};

const MypageReservationList: React.FC = () => {
  const companyCode = getSessionStorage('companyCode');
  const history = useHistory();
  const customerId = getLocalStorage('customerId');
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const timeOutRef = useRef<any>(null);

  const [customerData, setCustomerData] = useState<CustomerReservation[]>([]);

  const updateSize = () => {
    if (timeOutRef.current) {
      clearTimeout(timeOutRef.current);
    }
    timeOutRef.current = setTimeout(() => {
      const height = document.getElementsByTagName('body')[0]?.clientHeight || 0;
      const obj = { event: 'iframe_height', height };
      // 親へiframeの高さを送信
      // postMessage(<送信する値>, <送信先のドメイン>)
      window.parent.postMessage(obj, DOMAIN_POST_MESSAGE);
    }, 500);
  };

  useEffect(() => {
    // Save history access screen
    const paramsPost = { accessUrl: `${history?.location?.pathname + history?.location?.search}`, companyCode, customerBasicDataId: customerId || '' };
    accessHistoryApi(paramsPost);
    if (companyCode === COMPANY_CODE_POST_MESSAGE) {
      updateSize && updateSize();
      window.addEventListener('resize', updateSize);
    }

    getCustomerReservationList({ customerBasicDataId: customerId })
      .then((res) => {
        setCustomerData(Array.isArray(res) ? res : []);
      })
      .catch(() => {
        setCustomerData([]);
      });

    return () => {
      window.removeEventListener('resize', updateSize);
      clearTimeout(timeOutRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRowClick = (reservation: CustomerReservation) => {
    history.push({
      pathname: `/${companyCode}/mypage/customer/reservationChange`,
      state: { reservation },
    });
  };

  const columns: DataTableColumn[] = [
    {
      id: 'desiredTime',
      label: '予約日時',
      align: 'center',
      width: '50%',
      content(row: CustomerReservation, index) {
        return (
          <TableCell key={index} align="center">
            {row.desiredTime}
          </TableCell>
        );
      },
    },
    {
      id: 'orgName',
      label: '店舗',
      align: 'center',
      width: '35%',
      style: verticalLineStyle,
      content(row: CustomerReservation, index) {
        return (
          <TableCell key={index} align="center" style={verticalLineStyle}>
            {row.orgName}
          </TableCell>
        );
      },
    },
    {
      id: 'action',
      label: '',
      align: 'center',
      width: '15%',
      style: verticalLineStyle,
      content(row: CustomerReservation, index) {
        return (
          <TableCell
            key={index}
            align="center"
            style={{ ...verticalLineStyle, cursor: 'pointer' }}
            onClick={() => handleRowClick(row)}
          >
            <ChevronRightIcon fontSize="small" color="action" />
          </TableCell>
        );
      },
    },
  ];

  if (isDesktop) {
    return (
      <div className={classes.rootDesktop}>
        <MypageReservationListDesktop
          customerData={customerData}
          columns={columns}
        />
      </div>
    );
  }
  return (
    <div className={classes.rootMobile}>
      <MypageReservationListMobile
        customerData={customerData}
        columns={columns}
      />
    </div>
  );
};

export default MypageReservationList;
